// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2gIEN","inner":"Footer_inner__3kD_I"};